import { useTranslation as useI18nTranslation } from 'react-i18next';
import i18n from '../i18n/config';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useSharedTranslation = (namespace?: string): { t: (key: string, options?: Record<string, any>) => string } => {
  i18n.setDefaultNamespace(namespace || 'translation');
  const { t, ...rest } = useI18nTranslation();

  const customT = (key: string, options?: Record<string, any>): string => {
    const prefixedKey = namespace ? `${namespace}:${key}` : key;
    return t(prefixedKey, options || {});
  };

  return { t: customT, ...rest };
}

export const translate = (key: string, namespace?: string, options?: Record<string, any>): string => {
  const prefixedKey = namespace ? `${namespace}:${key}` : key;
  return i18n.t(prefixedKey, options || {});
};

export const namespaces = {
  caregiver: 'caregiver',
  family: 'family',
  public: 'public',
};
/* eslint-enable @typescript-eslint/no-explicit-any */
